(function() {
  function initMainNavListeners() {
    const mobileNavToggleButtons = document.querySelectorAll('.js-mobile-nav-toggle');
    const mobileNavDrawerButtons = document.querySelectorAll('.js-mobile-nav-drawer button');
    const mobileNavOverlay = document.querySelector('.js-mobile-nav-overlay');
    const mobileNavSearchInput = document.querySelector('mobile-nav-drawer .js-predictive-search-input');

    // Click outside handler - closes nav when clicking on overlay
    function handleClickOutside(e) {
      if (mobileNavOverlay && mobileNavOverlay.contains(e.target)) {
        toggleMobileNav(false);
      }
    }

    // Toggle mobile nav function
    function toggleMobileNav(isOpen, focusInput) {
      document.body.setAttribute('data-menu-active', isOpen.toString());
      if (isOpen) {
        document.addEventListener('click', handleClickOutside);
      } else {
        document.removeEventListener('click', handleClickOutside);
      }
      if (focusInput) {
        mobileNavSearchInput.focus();
      }
    }

    // Toggle mobile nav
    mobileNavToggleButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const isOpen = document.body.getAttribute('data-menu-active') === "true";
        let focusInput = false;
        if (e.target.dataset.searchToggle !== undefined) {
          focusInput = true;
        }
        toggleMobileNav(!isOpen, focusInput);
      });
    });
    
    // Toggle mobile nav drawer
    mobileNavDrawerButtons.forEach(button => {
      button.addEventListener('click', () => {
        const menu = button.closest('[data-active]');
        const isOpen = menu.getAttribute('data-active') === 'true';
        if (menu) {
          menu.setAttribute('data-active', !isOpen);
        }
      });
    });
  }

  function initMegaMenuPositioning() {
    const megaMenuTriggers = document.querySelectorAll('.group\\/nav');
    
    function positionMegaMenu(trigger, megaMenu) {
      if (!trigger || !megaMenu) return;
      
      const viewportWidth = window.innerWidth;
      
      // Reset any existing positioning
      megaMenu.style.transform = '';
      
      // Only apply positioning logic for viewports 1280px and wider
      if (viewportWidth >= 1280) {
        const triggerRect = trigger.getBoundingClientRect();
        const megaMenuRect = megaMenu.getBoundingClientRect();
        const megaMenuWidth = megaMenuRect.width || 900; // Use actual width or fallback to 900
        const padding = 16; // 1rem padding from screen edges
        
        // Calculate ideal position (left edge of mega menu aligns with left edge of trigger)
        const idealLeft = triggerRect.left;
        
        // Check if menu would overflow on the right
        const rightOverflow = (idealLeft + megaMenuWidth + padding) - viewportWidth;
        
        if (rightOverflow > 0) {
          // Menu would overflow right, shift it left using transform
          const translateX = idealLeft - (viewportWidth - megaMenuWidth - padding);
          megaMenu.style.transform = `translateX(-${translateX}px)`;
        }
      }
    }
    
    function updateAllMegaMenuPositions() {
      megaMenuTriggers.forEach(trigger => {
        const megaMenu = trigger.querySelector('nav-mega-menu');
        positionMegaMenu(trigger, megaMenu);
      });
    }
    
    // Update positions on window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateAllMegaMenuPositions, 100);
    });
    
    // Initial positioning
    updateAllMegaMenuPositions();
  }

  function updateHeaderHeight(elem = undefined) {
    const header = elem !== undefined ? document.querySelector(elem) : document.querySelector('header');
    if (header) {
      const headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
  }

  function initHeaderHeightTracking() {
    const header = document.querySelector('header');
    if (!header) return;

    // Set initial header height
    updateHeaderHeight();

    // Create ResizeObserver to watch for header size changes
    const resizeObserver = new ResizeObserver(() => {
      updateHeaderHeight();
    });

    // Start observing the header element
    resizeObserver.observe(header);

    // Also listen for window resize events as a fallback
    window.addEventListener('resize', () => updateHeaderHeight());

    // Listen for orientation changes on mobile devices
    window.addEventListener('orientationchange', () => {
      // Small delay to ensure layout has updated
      setTimeout(updateHeaderHeight, 100);
    });
  }

  function initAccordionTransitions() {
    const accordions = document.querySelectorAll('details');
    
    accordions.forEach(accordion => {
      const summary = accordion.querySelector('summary');
      const content = accordion.querySelector('summary + *');
      
      if (!summary || !content) return;
      
      setupAccordionStyles(content);
      setInitialAccordionState(accordion, content);
      attachAccordionClickHandler(accordion, summary, content);
    });
  }

  function setupAccordionStyles(content) {
    content.style.overflow = 'hidden';
    content.style.transition = 'max-height 250ms ease-in-out, opacity 250ms ease-in-out';
  }

  function setInitialAccordionState(accordion, content) {
    if (accordion.hasAttribute('open')) {
      showAccordionContent(content);
    } else {
      hideAccordionContent(content);
    }
  }

  function attachAccordionClickHandler(accordion, summary, content) {
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      
      const isCurrentlyOpen = accordion.hasAttribute('open');
      
      if (isCurrentlyOpen) {
        closeAccordion(accordion, content);
      } else {
        openAccordion(accordion, content);
      }
    });
  }

  function openAccordion(accordion, content) {
    accordion.setAttribute('open', '');
    
    const height = content.scrollHeight;
    content.style.maxHeight = '0px';
    content.style.opacity = '0';
    
    // Force reflow to ensure styles are applied
    content.offsetHeight;
    
    content.style.maxHeight = height + 'px';
    content.style.opacity = '1';
    
    // Clean up after animation
    setTimeout(() => {
      content.style.maxHeight = 'none';
    }, 250);
  }

  function closeAccordion(accordion, content) {
    const height = content.scrollHeight;
    content.style.maxHeight = height + 'px';
    content.style.opacity = '1';
    
    // Force reflow to ensure styles are applied
    content.offsetHeight;
    
    content.style.maxHeight = '0px';
    content.style.opacity = '0';
    
    // Remove open attribute after animation
    setTimeout(() => {
      accordion.removeAttribute('open');
    }, 250);
  }

  function showAccordionContent(content) {
    content.style.maxHeight = 'none';
    content.style.opacity = '1';
  }

  function hideAccordionContent(content) {
    content.style.maxHeight = '0px';
    content.style.opacity = '0';
  }

  function initVariantSwatches() {
    // Helper function to update variant image
    function updateVariantImage(productCard, variantId) {
      const imageContainer = productCard.querySelector('.product-card-image-container');
      if (!imageContainer) return;

      const mainImage = imageContainer.querySelector('.product-card-image');
      if (!mainImage) return;

      // Find the swatch button with this variant ID to get the image URL
      const swatch = productCard.querySelector(`.product-swatch__swatch[data-variant-id="${variantId}"]`);
      if (swatch && swatch.dataset.variantImage) {
        mainImage.src = swatch.dataset.variantImage;
        mainImage.dataset.variantId = variantId;
      }
    }

    // Helper function to update variant ID input
    function updateVariantIdInput(productCard, variantId) {
      const variantIdInput = productCard.querySelector('.pair_variant_id');
      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }
    }

    // Helper function to update button state
    function updateButtonState(productCard, variantId) {
      const button = productCard.querySelector('button[type="submit"]');
      if (!button) return;

      const availableVariantsStr = productCard.dataset.availableVariants;
      if (!availableVariantsStr) return;

      const availableVariants = availableVariantsStr.split(',');
      const isAvailable = availableVariants.includes(variantId.toString());
      
      button.disabled = !isAvailable;
    }

    // Helper function to sync variant select dropdown
    function syncVariantSelect(productCard, variantId) {
      const variantSelect = productCard.querySelector('.pair_variant_select');
      if (variantSelect && variantId) {
        variantSelect.value = variantId;
      }
    }

    // Helper function to update swatch active states
    function updateSwatchStates(container, activeSwatch) {
      const allSwatches = container.querySelectorAll('.product-swatch__swatch');
      allSwatches.forEach(swatch => swatch.classList.remove('active'));
      if (activeSwatch) {
        activeSwatch.classList.add('active');
      }
    }

    // Main function to handle variant selection
    function handleVariantSelection(productCard, variantId, variantUrl = null, activeSwatch = null) {
      // Update variant image
      updateVariantImage(productCard, variantId);
      
      // Update variant ID input
      updateVariantIdInput(productCard, variantId);
      
      // Update button state
      updateButtonState(productCard, variantId);
      
      // Update variant URL if provided
      if (variantUrl && productCard) {
        productCard.dataset.variantUrl = variantUrl;
      }
      
      // Sync variant select dropdown
      syncVariantSelect(productCard, variantId);
      
      // Update swatch states if container provided
      if (activeSwatch) {
        const container = activeSwatch.closest('.product-card__swatches');
        if (container) {
          updateSwatchStates(container, activeSwatch);
        }
      }
    }

    // Initialize variant select dropdowns
    const variantSelectors = document.querySelectorAll('.pair_variant_select');
    variantSelectors.forEach(select => {
      select.addEventListener('change', function() {
        const variantId = this.value;
        const productCard = select.closest('product-card');
        handleVariantSelection(productCard, variantId);
      });
    });

    // Initialize swatch containers
    const swatchContainers = document.querySelectorAll('.product-card__swatches');
    swatchContainers.forEach(container => {
      const swatches = container.querySelectorAll('.product-swatch__swatch');
      
      swatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
          const variantId = this.dataset.variantId;
          const variantUrl = this.dataset.variantUrl;
          const productCard = container.closest('product-card');
          
          handleVariantSelection(productCard, variantId, variantUrl, this);
        });
      });
    });
  }
  window.initCoddleVariantSwatches = initVariantSwatches;

  function initKlaviyoFormListener() {
    let klaviyoButton = document.querySelector('.open-klaviyo');
    if (klaviyoButton) {
        klaviyoButton.addEventListener('click', function () {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'XhCteS']);
        })
    }
  }

  function initProductFormListeners() {
    // Listen for product form submit and open cart drawer on success
    document.body.addEventListener('click', (e) => {
      if (e.target.classList.contains('js-product-form-submit')) {
        e.preventDefault();
        handleProductFormSubmit(e.target.closest('form'));
      }
    });
    
    function handleProductFormSubmit(form) {
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
        throw new Error(`HTTP error! status: ${response.status}`);
       }
      })
      .then(() => {
        // Success - open cart drawer
        if (typeof toggleCartDrawer === 'function') {
          toggleCartDrawer(true);
        }
        if (typeof window.refreshNavCartCount === 'function') {
          window.refreshNavCartCount();
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    };
  }

  document.addEventListener("DOMContentLoaded", () => {
    initMainNavListeners();
    initMegaMenuPositioning();
    initHeaderHeightTracking();
    initAccordionTransitions();
    initVariantSwatches();
    initKlaviyoFormListener();
    initProductFormListeners();
  });
})();